import { useForm } from "react-hook-form"
import { AdministrarPatEdit, modalPat, TipoTarjeta, UpdatePatDTO } from "../models/administrarPat"
import { useEffect, useState } from "react"
import { selectorTransversal } from "../../../../dtos/selector"
import { useToast } from "../../../../hooks/useToast"
import { Dominios, StatusCode, TipoProducto } from "../../../../utils/enums"
import { AxiosResponse } from "axios"
import { getValoresDominio } from "../../../../services/servicesDominio"
import { Dialog, DialogContent, DialogTitle, Grid2 } from "@mui/material"
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber"
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import MButton from "../../../../components/inputs/yup/materialui/mButton"
import { editarPat, getCuota, getTipoTarjeta, getValidarPat } from "../service/servicePat"
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { getBancos } from "../../../detalleMutuo/services/serviceSubsidios"
import { set } from "date-fns"
import { ListResponseDto } from "../../../../dtos/ListResponseDto"
import { Banco } from "../../../detalleMutuo/hooks/useSubsidioMutuo"
import { da, tr } from "date-fns/locale"

interface IProps {
    show: boolean
    datosEditar: AdministrarPatEdit | undefined
    onHide: () => void
    refresh: () => void
    isEditing?: boolean
}

const schema = yup.object().shape({
    id: yup.number().required(),
    llavePat: yup
        .string()
        .required("Llave PAT es requerida")
        .matches(/^[A-Za-z0-9]+$/, "Ingrese una Llave PAT válida"),

    numeroTarjeta: yup
        .string()
        .required("El número de tarjeta es requerido")
        .matches(/^[\d-]+$/, "Solo se permiten números y guiones"),
    nombreCompleto: yup.string().required("El nombre del cliente es requerido"),
    tipoTarjetaCodigo: yup.string().required("El tipo de tarjeta es requerido"),
    fechaVencimientoTarjeta: yup.date().typeError("La fecha de vencimiento es requerida").required("La fecha de vencimiento es requerida"),
    bancoCodigo: yup.string().required("El banco es requerido"),
    fechaPrimerDescuento: yup.date().typeError("La fecha de primer descuento es requerida").required("La fecha de primer descuento es requerida"),
    tipoCuota: yup.string().required("El tipo de cuota es requerido"),
    diaCobro: yup.string().typeError("El día de cobro es requerido").required("El día de cobro es requerido"),
    numeroMandato: yup
        .number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === '' ? null : value
        )
        .notRequired(),
    numeroOperacion: yup.string().required("El número de operación es requerido"),
    estado: yup.string().required("El estado es requerido"),
    montoCuota: yup
        .number()
        .typeError("El monto de cuota es requerido")
        .required("El monto de cuota es requerido")
        .min(0, "El monto de cuota no puede ser menor a 0"),
    codigoMoneda: yup.string().required("El tipo de moneda es requerido"),
});

const ModalPat: React.FC<IProps> = ({ show, datosEditar, onHide, refresh, isEditing = false }) => {

    const { addToast } = useToast();

    const [optionsBanco, setOptionsBanco] = useState<selectorTransversal[]>([]);
    const [optionsCuota, setOptionsCuota] = useState<selectorTransversal[]>([]);
    const [optionsDiaCobro, setOptionsDiaCobro] = useState<selectorTransversal[]>([]);
    const [optionsEstado, setOptionsEstado] = useState<selectorTransversal[]>([]);
    const [optionsMoneda, setOptionsMoneda] = useState<selectorTransversal[]>([]);
    const [optionsTarjeta, setOptionsTarjeta] = useState<selectorTransversal[]>([]);
    const [optionsGlobalQuotas, setOptionsGlobalQuotas] = useState<selectorTransversal[]>([]);
    const [optionsCuotaValor, setOptionsCuotaValor] = useState()
    const [montoCuota, setMontoCuota] = useState<number>(0);
    const [montoCuotaIntermedioOriginal, setMontoCuotaIntermedioOriginal] = useState<number>(0);
    const [codigoMonedaIntermedioOriginal, setCodigoMonedaIntermedioOriginal] = useState<string>('UF');


    const isValueEmpty = (value: any): boolean => {
        if (value === null || value === undefined) {
            return true;
        }
        if (typeof value === 'string' && value.trim() === '') {
            return true;
        }
        if (typeof value === 'number' && value === 0) {
            return true;
        }
        return false;
    };

    const isCreateMode = isValueEmpty(datosEditar?.llavePat) || isValueEmpty(datosEditar?.estado);

    const isTradicional = datosEditar?.tipoProducto === TipoProducto.MHT || datosEditar?.tipoProducto === TipoProducto.MHD;

    const {
        formState: { errors },
        handleSubmit,
        reset,
        trigger,
        setValue,
        control,
        watch
    } = useForm<modalPat>({
        mode: 'onBlur',
        resolver: yupResolver(schema),
    })
    const dataForm = watch();

    const datosPat = async () => {
        const resp = await getCuota(datosEditar!.mutuoId)
        if (resp.status === StatusCode.Ok) {
            const data = await resp.data
            setOptionsCuotaValor(data)
        }
    }

    useEffect(() => {
        const fetchDatos = async () => {
            if (show) {
                await datosPat();
            }
        };
        fetchDatos();

        if (isEditing && show) {
            const cargarDatosPat = async () => {

                const response = await getValidarPat(datosEditar!.mutuoId);

                if (response.status === StatusCode.Ok) {

                    const data = response.data;
                    const diaCobroFormateado = data.diacobro
                        ? String(data.diacobro).padStart(2, '0')
                        : '';

                    setValue('id', data.mutuoId || datosEditar?.mutuoId);
                    setValue('llavePat', data.llavepat);
                    setValue('bancoCodigo', data.bancoCodigo);
                    setValue('fechaPrimerDescuento', data.fechaprimerdescuento || new Date());
                    setValue('tipoCuota', data.tipocuota);
                    setValue('diaCobro', diaCobroFormateado);
                    setValue('numeroMandato', data.numeromandato ?? null);
                    setValue('numeroOperacion', data.numerooperacion);
                    setValue('estado', data.estado);
                    setValue('observaciones', data.observaciones || '');
                    setValue('nombreCompleto', data.nombrecliente);
                    setValue('numeroTarjeta', data.numerotarjeta);
                    setValue('fechaVencimientoTarjeta', data.fechavenctotarjeta);
                    setValue('montoCuota', data.montocuota);
                    setValue('codigoMoneda', data.codigomoneda);
                    setValue('tipoTarjetaCodigo', data.tipotarjetaCodigo);

                    setMontoCuota(data.montocuota ?? 0);
                    setMontoCuotaIntermedioOriginal(data.montocuota ?? 0);
                    setCodigoMonedaIntermedioOriginal(data.codigomoneda ?? 'UF');


                    trigger();
                }
            };

            cargarDatosPat();
        } else {
            reset();
            setValue('id', datosEditar?.mutuoId ?? 0)
            setValue('numeroOperacion', datosEditar?.numeroOperacion ?? '')
            setValue('nombreCompleto', datosEditar?.nombreCliente ?? '')
            setValue('llavePat', datosEditar?.numeroSolicitud != null ? `${datosEditar.numeroSolicitud}A` : '')
        }
    }, [isEditing, show, datosEditar, setValue]);

    const tipoBanco = async () => {
        const resp: AxiosResponse<ListResponseDto<Banco>> = await getBancos()
        if (resp.status === StatusCode.Ok) {
            const data: Banco[] = await resp.data.items;
            const options = data.map((m: any) => ({
                label: m.descripcion,
                value: m.codigo,
            }));
            setOptionsBanco(options)
        }
        return;
    }

    const tipoCuota = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_CUOTA)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsGlobalQuotas(data);
        }

        return;
    }

    const tipoDiaCobro = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.DIA_COBRO)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsDiaCobro(data)
        }
        return;
    }

    const tipoEstado = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.ESTADO_PAC)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsEstado(data)
        }
        return;
    }

    const tipoMoneda = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_MONEDA)
        if (resp.status === StatusCode.Ok) {
            const data: selectorTransversal[] = await resp.data.items;
            setOptionsMoneda(data)
        }
        return;
    }
    const tipoTarjeta = async () => {
        const resp: AxiosResponse<ListResponseDto<TipoTarjeta>> = await getTipoTarjeta()
        if (resp.status === StatusCode.Ok) {
            const data: TipoTarjeta[] = await resp.data.items;
            const options = data.map((m: any) => ({
                label: m.descripcion,
                value: m.codigo,
            }));
            setOptionsTarjeta(options)
        }
        return;
    }

    useEffect(() => {
        const inicializar = async () => {
            await tipoBanco();
            await tipoCuota();
            await tipoDiaCobro();
            await tipoEstado();
            await tipoMoneda();
            await tipoTarjeta();
        };

        inicializar();
    }, []);

    useEffect(() => {

        if (datosEditar?.tipoProducto === TipoProducto.MHT || datosEditar?.tipoProducto === TipoProducto.MHD) {
            setOptionsCuota(optionsGlobalQuotas.filter(x => x.value === 'Minima'))
        } else {
            setOptionsCuota(optionsGlobalQuotas)
        }

    }, [datosEditar])

    const onSubmit = async (data: modalPat) => {
        const patData: UpdatePatDTO = {
            MutuoId: datosEditar!.mutuoId,
            LlavePat: data.llavePat,
            NumeroOperacion: data.numeroOperacion,
            NombreCliente: data.nombreCompleto,
            NumeroTarjeta: String(data.numeroTarjeta),
            FechaVenctoTarjeta: data.fechaVencimientoTarjeta,
            FechaPrimerDescuento: data.fechaPrimerDescuento,
            Estado: data.estado,
            Observaciones: data.observaciones ?? null,
            TipoCuota: data.tipoCuota,
            MontoCuota: data.montoCuota,
            DiaCobro: Number(data.diaCobro),
            BancoCodigo: data.bancoCodigo,
            CodigoMoneda: data.codigoMoneda,
            TipoTarjetaCodigo: data.tipoTarjetaCodigo,
            NumeroMandato: data.numeroMandato ?? 0,
            CuotaMaxima: optionsCuotaValor?.['CuotaMaxima'],
            CuotaMinima: optionsCuotaValor?.['CuotaMinima'],
            CuotaIntermedia: datosEditar?.montoCuota

        };

        const response = await editarPat(patData);
        if (response.status === StatusCode.Ok) {
            addToast({
                mostrar: true,
                titulo: 'Éxito',
                tipo: 'Success',
                mensaje: datosEditar ? 'La acción se ha completado con éxito. Recuerde regenerar en forma manual, el dividendo vigente de esta operación, para que los cambios se vean reflejados.'
                    : 'La acción se ha completado con éxito. Recuerde regenerar en forma manual, el dividendo vigente de esta operación, para que los cambios se vean reflejados.'
            });
            refresh();
            onHide();
            reset();
        }
    }

    function customOnHide() {
        reset()
        onHide()
    }

    const getTipoMonedaByCuota = (tipoCuota: string | null | undefined) => {
        if (tipoCuota === 'Minima' || tipoCuota === 'Maxima') {
            return 'UF';
        } else if (tipoCuota === 'Intermedia') {
            return datosEditar?.codigoMoneda || 'UF';
        }

        return datosEditar?.codigoMoneda || 'UF';
    }

    const disabled: boolean = dataForm.tipoCuota === "Minima" || dataForm.tipoCuota === "Maxima";

    useEffect(() => {
        if (disabled && dataForm.codigoMoneda !== 'UF') {
            setValue('codigoMoneda', 'UF');
        }
    }, [disabled, dataForm.codigoMoneda, setValue]);

    const handleTipoCuota = (value: string | null) => {
        if (!value)
            return;
        setMontoCuota(datosEditar?.montoCuota || 0);
        const tipoMonedaSeleccionada = getTipoMonedaByCuota(value);

        if (value === 'Minima' && optionsCuotaValor) {
            setValue('montoCuota', optionsCuotaValor['CuotaMinima'] ?? 0);
            setValue('codigoMoneda', tipoMonedaSeleccionada)

        } else if (value === 'Maxima' && optionsCuotaValor) {
            setValue('montoCuota', optionsCuotaValor['CuotaMaxima'] ?? 0);
            setValue('codigoMoneda', tipoMonedaSeleccionada)

        }
        if (value === 'Intermedia') {
            if (isEditing && show) {
                setValue('montoCuota', montoCuotaIntermedioOriginal);
                setValue('codigoMoneda', codigoMonedaIntermedioOriginal);
            } else {
                setValue('montoCuota', 0);
                setValue('codigoMoneda', 'UF');
            }
        }

        if (!isEditing && (value === 'Minima' || value === 'Maxima')) {
            setValue('codigoMoneda', 'UF');
        }

        trigger(['montoCuota', 'codigoMoneda']);

    }


    return (
        <Dialog
            open={show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>
                {isEditing ? 'Editar PAT' : 'Crear PAT'}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={3}>
                            <InputText
                                name="llavePat"
                                control={control}
                                label='Llave'
                                error={errors.llavePat}
                                desabilitado={!isCreateMode}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="nombreCompleto"
                                control={control}
                                label="Nombre cliente tarjeta"
                                error={errors.nombreCompleto}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="tipoTarjetaCodigo"
                                control={control}
                                label="Tipo tarjeta"
                                options={optionsTarjeta}
                                error={errors.tipoTarjetaCodigo}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="numeroTarjeta"
                                control={control}
                                label="N° Tarjeta"
                                error={errors.numeroTarjeta}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputFecha
                                name="fechaVencimientoTarjeta"
                                control={control}
                                label="Fecha vencimiento tarjeta"
                                fecha={dataForm.fechaVencimientoTarjeta}
                                error={errors.fechaVencimientoTarjeta}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="bancoCodigo"
                                control={control}
                                label="Banco"
                                options={optionsBanco}
                                error={errors.bancoCodigo}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputFecha
                                name="fechaPrimerDescuento"
                                control={control}
                                label="Fecha primer descuento"
                                error={errors.fechaPrimerDescuento}
                                fecha={dataForm.fechaPrimerDescuento}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="tipoCuota"
                                control={control}
                                label="Tipo cuota"
                                options={optionsCuota}
                                error={errors.tipoCuota}
                                disabled={isTradicional && isEditing}
                                onChange={(value) => handleTipoCuota(value)}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="diaCobro"
                                control={control}
                                label="Dia cobro"
                                options={optionsDiaCobro}
                                error={errors.diaCobro}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputNumber
                                name="numeroMandato"
                                control={control}
                                label="N° mandato"
                                decimales={4}
                                error={errors.numeroMandato}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="numeroOperacion"
                                control={control}
                                label="N° operacion"
                                error={errors.numeroOperacion}
                                desabilitado={true}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="estado"
                                control={control}
                                label="Estado"
                                options={optionsEstado}
                                error={errors.estado}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputNumber
                                name="montoCuota"
                                control={control}
                                label="Monto cuota"
                                decimales={4}
                                error={errors.montoCuota}
                                disabled={isTradicional && isEditing || disabled}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputSelect
                                name="codigoMoneda"
                                control={control}
                                label="Tipo moneda"
                                options={optionsMoneda}
                                error={errors.codigoMoneda}
                                disabled={dataForm.tipoCuota === "Minima" || dataForm.tipoCuota === "Maxima"}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="observaciones"
                                control={control}
                                label="Observaciones"
                            />
                        </Grid2>
                    </Grid2>
                </form>
                <Grid2 container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                    <Grid2>
                        <MButton variant="contained" onClick={handleSubmit(onSubmit)}>Guardar</MButton>
                    </Grid2>
                    <Grid2>
                        <MButton variant="contained" color="inherit" onClick={customOnHide}>Cancelar</MButton>
                    </Grid2>
                </Grid2>
            </DialogContent>
        </Dialog>
    )
}

export default ModalPat;

